import { useParams } from "react-router";

export function useServerId() {
	let { server_id } = useParams<{
		server_id: string;
	}>();

	return server_id;
}
